// extracted by mini-css-extract-plugin
export default {"note":"styles_note__zONln","noteHidden":"styles_noteHidden__xR9Be","info":"styles_info__Amiae","buttons":"styles_buttons__BrZ4-"};